import Portal from '../Atoms/Portal.js';
import Typography from '../Atoms/Typography.js';
import React__default, { useEffect, useState } from 'react';
import { useDetectRTL } from '../Utils/rtl.hook.js';
import classNames from './../external_lib/classnames/index.js';
import CrossIcon from '../assets/icons/cross.icon.js';
import { useIsMobile } from '../Utils/isMobile.util.js';
import DownArrow from '../assets/icons/down-arrow.icon.js';
import LazyImage from '../Atoms/LazyImage.js';
import { AnimatePresence } from './../external_lib/framer-motion/dist/es/components/AnimatePresence/index.js';
import { LazyMotion } from './../external_lib/framer-motion/dist/es/components/LazyMotion/index.js';
import { domAnimation } from './../external_lib/framer-motion/dist/es/render/dom/features-animation.js';
import { m } from './../external_lib/framer-motion/dist/es/render/dom/motion-minimal.js';

function Dialog(_a) {
    var children = _a.children, _b = _a.footer, footer = _b === void 0 ? true : _b, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, title = _a.title, subTitle = _a.subTitle, onClose = _a.onClose, layoutId = _a.layoutId, headerImage = _a.headerImage, _d = _a.showHeaderImage, showHeaderImage = _d === void 0 ? false : _d, classes = _a.classes, dialogRef = _a.dialogRef, removeCloseIcon = _a.removeCloseIcon, removeBackdrop = _a.removeBackdrop, fullScreen = _a.fullScreen, uniqueKey = _a.uniqueKey, _e = _a.offsetLeft, offsetLeft = _e === void 0 ? 0 : _e, _f = _a.offsetTop, offsetTop = _f === void 0 ? 0 : _f, onBack = _a.onBack, _g = _a.hasBack, hasBack = _g === void 0 ? false : _g;
    var _h = React__default.useState(isOpen), _isOpen = _h[0], setIsOpen = _h[1];
    useEffect(function () { return setIsOpen(isOpen); }, [isOpen]);
    var isRTL = useDetectRTL();
    var isMobile = useIsMobile();
    var _onClose = function () {
        setIsOpen(false);
        if (onClose) {
            onClose();
        }
    };
    var showDialogHeader = title || subTitle || !removeCloseIcon;
    // const animation = useCallback(() => {
    //   let y = isMobile ? 500 : -100;
    //   if (dialogRef) {
    //     const dialogPosition = dialogRef?.getBoundingClientRect();
    //     if (dialogPosition && !isMobile) {
    //       y = -1 * (dialogPosition.top + dialogPosition.height);
    //     }
    //   }
    //   return {
    //     hidden: {
    //       // scale: isMobile ? 0.95 : 0,
    //       // y,
    //       opacity: 0
    //     },
    //     visible: {
    //       opacity: 1
    //       // scale: 1,
    //       // y: 0
    //     }
    //   };
    // }, [isMobile, dialogRef]);
    var _j = useState({}), styles = _j[0], updateStyles = _j[1];
    var recordPositionUpdates = function (_dialogRef) {
        var dialogPosition = _dialogRef === null || _dialogRef === void 0 ? void 0 : _dialogRef.getBoundingClientRect();
        updateStyles({
            top: dialogPosition.top + dialogPosition.height + offsetTop,
            left: dialogPosition.left + offsetLeft
        });
    };
    useEffect(function () {
        if (dialogRef && !isMobile && _isOpen) {
            recordPositionUpdates(dialogRef);
            var func_1 = function () { return recordPositionUpdates(dialogRef); };
            document.addEventListener('scroll', func_1, true);
            return function () { return document.removeEventListener('scroll', func_1, true); };
        }
        else {
            updateStyles({});
        }
    }, [dialogRef, isMobile, _isOpen]);
    var variants = {
        visible: {
            opacity: 1,
            scale: 1,
            y: 0
        },
        hidden: {
            opacity: 0,
            scale: 0.95,
            y: '30vh'
        }
    };
    var transition = {
        duration: 0.15,
        ease: 'easeInOut'
    };
    return (React__default.createElement(Portal, null,
        React__default.createElement(AnimatePresence, null,
            React__default.createElement(LazyMotion, { features: domAnimation },
                React__default.createElement("div", null, _isOpen && (React__default.createElement("div", { className: classNames('dialog', { dialog_positioned: dialogRef }, classes) },
                    React__default.createElement("div", { key: "".concat(uniqueKey, "modal-bg"), 
                        // initial={{ opacity: 0 }}
                        // animate={{ opacity: 0.9 }}
                        // exit={{ opacity: 0 }}
                        className: classNames('dialog__background', {
                            no_backdrop: removeBackdrop
                        }), onClick: _onClose }),
                    React__default.createElement(m.div, { layoutId: layoutId, key: "".concat(uniqueKey, "modal"), 
                        // layoutId={`${uniqueKey}modal`}
                        // variants={animation()}
                        // initial={'hidden'}
                        // animate={'visible'}
                        // exit={'hidden'}
                        className: "dialog__content", style: styles, initial: "hidden", animate: "visible", exit: "hidden", variants: variants, transition: transition },
                        React__default.createElement("div", { className: "dialog__inner_content" },
                            showHeaderImage && (React__default.createElement("div", { className: "dialog__header_image" },
                                React__default.createElement(LazyImage, { src: headerImage, alt: 'header-image' }))),
                            showDialogHeader && (React__default.createElement("div", { className: classNames('dialog__header', {
                                    title_exists: title || subTitle,
                                    dialog__image: showDialogHeader
                                }) },
                                hasBack && (React__default.createElement("div", { className: "dialog__back_button" },
                                    React__default.createElement(DownArrow, { className: "dialog__back_button_icon", onClick: onBack, color: "#151515" }))),
                                React__default.createElement("div", { className: "dialog__title" },
                                    title ? (React__default.isValidElement(title) ? (title) : (React__default.createElement(Typography, { variant: "headingTwo", classes: "dialog__title--text" }, title))) : null,
                                    subTitle ? (React__default.isValidElement(subTitle) ? (subTitle) : (React__default.createElement(Typography, { variant: "bodyTextOne", classes: "dialog__subtitle" }, subTitle))) : null),
                                !removeCloseIcon && (React__default.createElement("div", { className: classNames('dialog__close', {
                                        rtl: isRTL
                                    }), onClick: _onClose },
                                    React__default.createElement(CrossIcon, null))))),
                            children !== null && (React__default.createElement("div", { id: "dialog__body", className: classNames('dialog__body', {
                                    'dialog__body--full-screen': fullScreen
                                }) }, children)),
                            footer ? (React__default.createElement("div", { className: classNames('dialog__footer', { rtl: isRTL }) }, footer)) : null)))))))));
}

export { Dialog as default };
//# sourceMappingURL=Dialog.js.map
